/* eslint-disable no-param-reassign */
import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import _ from 'underscore';
import { ViewSuggestionType, maxHeadlineCount, maxDescriptionCount } from './ad-strength-helper';
import { AdStrengthSuggestionController } from './rsa-ad-strength-suggestion-picker';
import { AdStrengthSuggestionRepository } from './rsa-ad-strength-suggestion-repository';
import { viewInlineSuggestion } from './rsa-ad-strength-suggestion';

let controller;

export const containerExists = container => (!_.isEmpty(container) && container.length > 0);

export const renderContainer = (content, container) => {
  if (containerExists(container)) {
    ReactDOM.render(
      content,
      _.first(container)
    );
  }
};

export const renderNoSuggestion = (container, i18n) => {
  const noSuggestion = (
    <div>
      {i18n.getString('Ad_Strength_Suggestion_NoSuggestion')}
      <span>&nbsp;</span>
      <a
        className="HelpTopic"
        query="help:app54711"
        href="#!"
        aria-label={i18n.getString('Ad_Strength_Suggestion_NoSuggestion_Help')}
      >
        {i18n.getString('Ad_Strength_Suggestion_NoSuggestion_Help')}
      </a>
    </div>
  );
  renderContainer(noSuggestion, container);
};

const renderUpdateSuggestion = (i18n, viewModel, assetType) => {
  let suggestions = $(`.ad-strength-suggestion-detail-suggestion.${assetType}`);
  if (!containerExists(suggestions)) {
    suggestions = $(`.ad-strength-suggestion-detail-suggestion-disabled.${assetType}`);
  }
  if (!containerExists(suggestions)) {
    return;
  }
  let hiddenSuggestionCount = 0;
  let viewModelShowCount = 0;
  let availableNewAsset = true;
  if (assetType === ViewSuggestionType.Headline) {
    viewModelShowCount = viewModel.showHeadlineCount();
    availableNewAsset = viewModelShowCount < maxHeadlineCount;
  } else if (assetType === ViewSuggestionType.Description) {
    viewModelShowCount = viewModel.showDescriptionCount();
    availableNewAsset = viewModelShowCount < maxDescriptionCount;
  } else {
    return;
  }
  const type = assetType === ViewSuggestionType.Headline ? 'Headline' : 'Description';
  _.each(suggestions, (suggestion) => {
    const content = suggestion.lastChild;
    if (!_.isEmpty(content)) {
      const suggestionContent = content.textContent.toLowerCase();
      const index = _.findIndex(_.range(viewModelShowCount), i =>
        suggestionContent === `${viewModel[`${type}${i}`]()}`.toLowerCase());
      if (index !== -1) {
        suggestion.style.display = 'none';
        hiddenSuggestionCount += 1;
      } else {
        suggestion.style.display = 'inline-block';
      }
    }
  });

  const noAvailableNewAssetContainer = $(`.ad-strength-suggestion-detail-no-new-asset-container.${assetType}`);

  const index = assetType === ViewSuggestionType.Headline ?
    _.findIndex(
      _.range(viewModel.showHeadlineCount()),
      i => _.isEmpty(`${viewModel[`Headline${i}`]()}`)
    ) :
    _.findIndex(
      _.range(viewModel.showDescriptionCount()),
      i => _.isEmpty(`${viewModel[`Description${i}`]()}`)
    );
  const hasEmptyAssetToAdd = index !== -1;

  if (!hasEmptyAssetToAdd && !availableNewAsset && hiddenSuggestionCount < suggestions.length) {
    const noAvailableNewAssetContent = assetType === ViewSuggestionType.Headline ?
      i18n.getString('Ad_Strength_Suggestion_NoSuggestion_Headline_Number_Limit') :
      i18n.getString('Ad_Strength_Suggestion_NoSuggestion_Description_Number_Limit');
    if (containerExists(noAvailableNewAssetContainer)) {
      _.first(noAvailableNewAssetContainer).style.display = 'flex';
    }
    const noAvailableNewAssetContentContainer = $(`.ad-strength-suggestion-detail-no-new-asset-content.${assetType}`);
    renderContainer(noAvailableNewAssetContent, noAvailableNewAssetContentContainer);

    // Disable all suggestions
    _.each(suggestions, (suggestion) => {
      suggestion.className = `ad-strength-suggestion-detail-suggestion-disabled ${assetType}`;
    });
  } else {
    if (containerExists(noAvailableNewAssetContainer)) {
      _.first(noAvailableNewAssetContainer).style.display = 'none';
    }

    // Enable all suggestions
    _.each(suggestions, (suggestion) => {
      suggestion.className = `ad-strength-suggestion-detail-suggestion ${assetType}`;
    });
  }

  // No recommendations available.
  const noSuggestionContainers = $(`.ad-strength-suggestion-detail-nosuggestion-container.${assetType}`);
  if (hiddenSuggestionCount === suggestions.length) {
    renderNoSuggestion(noSuggestionContainers, i18n);
  } else {
    renderContainer('', noSuggestionContainers);
  }
};

export const updateAdStrengthSuggestion = (i18n, viewModel) => {
  const container = $('.ad-strength-suggestions-detail');
  if (containerExists(container)
    && _.first(container).style.display === 'block') {
    renderUpdateSuggestion(i18n, viewModel, ViewSuggestionType.Headline);
    renderUpdateSuggestion(i18n, viewModel, ViewSuggestionType.Description);
  }
};

export const renewAdStrengthSuggestion = (options) => {
  const {
    i18n, viewModel, appState, token, odataPath, isForVNext,
  } = options;
  const container = $('.ad-strength-suggestions-detail');
  // Renew the suggestions when suggestion pannel is open
  if (containerExists(container)
    && _.first(container).style.display === 'block') {
    const headlineConatiner = container.find('.ad-strength-suggestion-detail-suggestions-container.headline');
    const descriptionConatiner = container.find('.ad-strength-suggestion-detail-suggestions-container.description');
    let suggestionType = null;
    if (containerExists(headlineConatiner)) {
      suggestionType = ViewSuggestionType.Headline;
    } else if (containerExists(descriptionConatiner)) {
      suggestionType = ViewSuggestionType.Description;
    }

    let action = null;
    const currentActionContainer = container.find('.ad-strength-suggestion-current-action');
    if (containerExists(currentActionContainer)) {
      action = _.first(currentActionContainer).textContent;
    }

    if (!_.isEmpty(suggestionType)) {
      const repository = new AdStrengthSuggestionRepository({
        viewModel,
        appState,
        token,
        odataPath,
      });
      viewInlineSuggestion(i18n, viewModel, repository, suggestionType, action, isForVNext);
    }
  }
};
export const isViewSuggestionApplied = (viewModel, assetType, suggestionContent = '') => {
  let viewModelShowCount = 0;
  let type;
  if (assetType === ViewSuggestionType.Headline) {
    viewModelShowCount = viewModel.showHeadlineCount() > maxHeadlineCount ?
      maxHeadlineCount : viewModel.showHeadlineCount();
    type = 'Headline';
  } else if (assetType === ViewSuggestionType.Description) {
    viewModelShowCount = viewModel.showDescriptionCount() > maxDescriptionCount ?
      maxDescriptionCount : viewModel.showDescriptionCount();
    type = 'Description';
  }
  const index = _.findIndex(_.range(viewModelShowCount), i =>
    suggestionContent.toLowerCase() === `${viewModel[`${type}${i}`]()}`.toLowerCase());

  return (index !== -1);
};

export const viewSuggestionMeasurement = (viewModel, viewSuggestionIds) => {
  let combinedViewSuggestionIds = viewModel.viewSuggestionIds || [];
  combinedViewSuggestionIds = combinedViewSuggestionIds.concat(viewSuggestionIds);
  viewModel.viewSuggestionIds = _.uniq(combinedViewSuggestionIds);
};

export const applySuggestionMeasurement = (viewModel, suggestionId) => {
  const combinedApplySuggestionIds = viewModel.applySuggestionIds || [];
  combinedApplySuggestionIds.push(suggestionId);
  viewModel.applySuggestionIds = _.uniq(combinedApplySuggestionIds);
};

export const returnSuggestionMeasurement = (viewModel, returnSuggestionIds) => {
  let combinedReturnSuggestionIds = viewModel.returnSuggestionIds || [];
  combinedReturnSuggestionIds = combinedReturnSuggestionIds.concat(returnSuggestionIds);
  viewModel.returnSuggestionIds = _.uniq(combinedReturnSuggestionIds);
};

/*
 * Attaches focus, input event listeners to ad text fields
 */
export const attachAdStrengthSuggestionHelpers = ({
  element,
  viewModel,
  appState,
  token,
  odataPath,
  assetType,
  i18n,
}) => {
  // add the class so that click in the input will not trigger picker to be hidden
  element.addClass('ad-strength-suggestion-helper-area');

  element.on('input keyup focus', (event) => {
    const { type, target, key } = event;

    const {
      selectionStart, selectionEnd,
    } = target;
    // Ignore if any text is selected, we are only interested in the cursor
    if (selectionStart !== selectionEnd) {
      return;
    }

    // Ignore escape key up since it shouldn't prompt any helper
    if (type === 'keyup' && key === 'Escape') {
      return;
    }

    if (_.isEmpty(controller)) {
      controller = new AdStrengthSuggestionController({
        container: $(document.body),
        appState,
        token,
        odataPath,
        i18n,
      });
    }

    controller.getAdStrengthSuggestion({
      assetType,
      target,
      input: target.value,
      viewModel,
      isInitPicker: type === 'focus',
    });
  });
};
